import Meta from "../util/Meta";


export class ApiCredencial {

    static async get(dados: { cpf: string, nascimento: string, token: string }): Promise<ICredResponse> {
        return await new Promise((res, rej) => {
            fetch(Meta.get('root') + '/credencial', {
                method: 'POST',
                body: JSON.stringify(dados),
                headers: {
                    'Content-Type': 'application/json',
                    // [Meta.get('_csrf_header')]: Meta.get('_csrf')
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        return res.json() as Promise<ICredResponse>
                    } else if (res.status === 404)
                        throw new Error('Credencial vencida ou não existente. Procure nossos canais de atendimento.');
                    else if (res.status === 400)
                        throw new Error('Sessão expirada. Por favor tente novamente.');
                    else {
                        throw new Error(`Erro inesperado: [${res.status}] ${res.statusText}`);
                    }
                })
                .then(res)
                .catch(rej);
        });
    }
}

export interface ICredencial {
    nome: string;
    matricula: string;
    nucpf: string;
    dtvencto: string;
    dtnascimen: string;
    valida: boolean;
    dependente: boolean;
    foto: string;
    cdcategori: number;
    categoria: {
        nome: string;
        nomeImpressao: string;
        pleno: boolean;
    },
}

export interface ICredResponse extends ICredencial {
    dependentes: ICredencial[] | any[]
}